import SparkMD5 from "spark-md5";
import { EventEmitter } from "eventemitter3";

export default class Md5Service extends EventEmitter {
  constructor(chunkSize) {
    super();
    this.currentPercent = 0;
    this.chunkSize = chunkSize || 2097152;
    this.reader = new FileReader();
    this.spark = new SparkMD5.ArrayBuffer();
  }

  start(file) {
    this.currentPercent = 0;
    const chunkSize = this.chunkSize;
    const chunks = Math.ceil(file.size / chunkSize);
    let currentChunk = 0;
    this.reader.onloadend = (e) => {
      if (!e.target?.result) return;
      this.spark.append(e.target?.result);
      currentChunk++;
      if (currentChunk < chunks) return loadNext();
      const result = this.spark.end();
      this.emit("complete", result);
    };
    this.reader.onerror = (err) => this.emit("error", err);
    const loadNext = () => {
      const start = currentChunk * chunkSize;
      const end =
        start + chunkSize >= file.size
          ? file.size
          : start + chunkSize;
      this.reader.readAsArrayBuffer(file.slice(start, end));
      const percent = Math.floor((currentChunk / chunks) * 100);
      if (this.currentPercent !== percent) {
        this.currentPercent = percent;
        this.emit("progress", percent);
      }
    };
    loadNext();
  }

  abort() {
    try {
      this.spark.reset();
      this.reader.abort();
    } catch (err) {
    
    } finally {
      this.emit("abort"); 
    }
  }
}
